import { Injectable } from '@angular/core';

@Injectable()
export class ScrollService {

    constructor() { }

    setDocumentTop(container, top) {
        container.scrollTop = top;
    }

    getDocumentTop(container) {
        return container.scrollTop;
    }

    getWindowHeight(container) {
        return container.offsetHeight;
    }

    getScrollHeight(container) {
        return container.scrollHeight;
    }

    setScrollBottom(container, func) {
        this.removeScrollBottom(container);
        container.addEventListener('scroll', () => {
            if (this.getScrollHeight(container) <= this.getWindowHeight(container) + this.getDocumentTop(container)) {
                func();
            }
        });
    }

    removeScrollBottom(container) {
        container.removeAllListeners('scroll');
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/scroll.service.ts